import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css'

//import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

const MY_ICONS = {
    folder: 'mdi-folder',
    account_circle: 'mdi-account-circle',
    login: 'mdi-login',
    event: 'mdi-calendar-today',
    cash: 'mdi-cash',
    balance: 'mdi-wallet'
}

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#173347',
        secondary: '#e76f51',
        accent: '#e76f51',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        background: '#f8f5ef'
      },
    },
  },
  icons: {
    iconfont: 'mdi',
    values: MY_ICONS
  },
});
